import { useEffect } from 'react';
import { Prototype2Provider, usePrototype2 } from './Prototype2Context';
import Screen01DefineNarrative from './screens/Screen01DefineNarrative';
import Screen02ReviewOutline from './screens/Screen02ReviewOutline';
import Screen03DraftReport from './screens/Screen03DraftReport';

const ScreenSwitch = () => {
  const { currentScreen } = usePrototype2();
  switch (currentScreen) {
    case '01-define-narrative':
      return <Screen01DefineNarrative />;
    case '02-review-outline':
      return <Screen02ReviewOutline />;
    case '03-draft-report':
      return <Screen03DraftReport />;
    default:
      return null;
  }
};

const TAILWIND_SCRIPT_ID = 'prototypes-tailwind-cdn';
const INTER_LINK_ID = 'prototypes-inter-font';
const HIDE_APP_CHROME_STYLE_ID = 'prototypes-hide-app-chrome';

const Prototype2Page = () => {
  useEffect(() => {
    const tw = document.createElement('script');
    tw.id = TAILWIND_SCRIPT_ID;
    tw.src = 'https://cdn.tailwindcss.com';
    tw.onload = () => {
      const w = window as unknown as { tailwind?: { config?: Record<string, unknown> } };
      if (w.tailwind) {
        w.tailwind.config = { corePlugins: { preflight: false } };
      }
    };

    const inter = document.createElement('link');
    inter.id = INTER_LINK_ID;
    inter.rel = 'stylesheet';
    inter.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';

    const hideAppChrome = document.createElement('style');
    hideAppChrome.id = HIDE_APP_CHROME_STYLE_ID;
    hideAppChrome.textContent = '.footer { display: none !important; }';

    document.head.append(tw, inter, hideAppChrome);

    return () => {
      document.getElementById(TAILWIND_SCRIPT_ID)?.remove();
      document.getElementById(INTER_LINK_ID)?.remove();
      document.getElementById(HIDE_APP_CHROME_STYLE_ID)?.remove();
    };
  }, []);

  return (
    <Prototype2Provider>
      <div className="tw relative w-full h-full overflow-hidden">
        <ScreenSwitch />
      </div>
    </Prototype2Provider>
  );
};

export default Prototype2Page;
